import { jsonParseLinter } from '@codemirror/lang-json';
import { linter } from '@codemirror/lint';

const jsonLinter = linter(jsonParseLinter());

export default jsonLinter;
